import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {WardApi} from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';

@Component({
  selector: 'app-wards',
  templateUrl: './ward.component.html',
  styleUrls: ['./ward.component.scss'],
  providers:[WardApi,BaToastNotificationService]
})

@Injectable()
export class WardComponent implements OnInit {

  private wardSource = new BehaviorSubject<object>({})
  ward = this.wardSource.asObservable();

  private wardsSource = new BehaviorSubject<object>([])
  wards = this.wardsSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected wardService:WardApi, private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getConstituencies(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getConstituencies(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getConstituencies(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.wardService.find({
      order: "id DESC",
      include: ['county'],
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.wardsSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.wardService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.wardService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.wardsSource.next(results.data.wards);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateWardSource(data){
    this.wardSource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.wardSource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/wards/ward.component.ts